import React from "react";
import styles from "./StudentList.module.scss";

const renderItems = (array = []) => {
	return array.map(({ node }, i) => {
		return (
			<div
				key={"list-" + i}
				className="row justify-content-between pb-4 pb-md-0"
			>
				<div className="col-12 col-md-4 col-lg-3">
					<div className={styles.row}>
						<div className={styles.line}>
							<b className={styles.collaborator_name}>
								{node.title + " " + node.name}
							</b>
							{node.isAlumni && (
								<b className={styles.graduation_date}>
									{node.node_locale === "th"
										? "จบการศึกษาปีพ.ศ."
										: "Graduated in "}
									{node.graduationYear}
								</b>
							)}
						</div>
					</div>
				</div>
				<div className={styles.lineBetween} />
				<div className={"col-12 col-md-7 col-lg-8 " + styles.line}>
					{node.isAlumni ? (
						<span className="pb-md-2">
							<span style={{ fontWeight: "bold" }}>
								Final thesis:{" "}
							</span>{" "}
							{node.finalThesis && node.finalThesis.content}
						</span>
					) : (
						node.researchSubject && node.researchSubject.content
					)}
					{node.currentPosition &&
						node.currentPosition &&
						node.currentPosition.content !== "-" && (
							<span>
								<span style={{ fontWeight: "bold" }}>
								{node.node_locale  === "th"
													? "ตำแหน่งงานปัจจุบัน: "
													: "Current position: "}
									
								</span>
								{node.currentPosition &&
									node.currentPosition.content}
							</span>
						)}
				</div>
			</div>
		);
	});
};

const StudentList = props => {
	return <div className={props.className}>{renderItems(props.list)}</div>;
};

export default StudentList;



// WEBPACK FOOTER //
// ./src/components/StudentList/index.js